import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import LeftArrow from "../../assets/leftarrow.svg";
import RightArrow from "../../assets/rightarrow.svg";
import { Link } from "react-router-dom";
import {
  changeAttribute,
  addProduct,
  removeProduct,
} from "../../redux/features/cartSlice";
import { mapStateToProps } from "../../redux/store";
const Product = styled.div`
  padding: 0 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  & + & {
    margin-top: 2.5rem;
  }
  @media screen and (min-width: 768px) {
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    align-items: unset;
    & > * {
      flex: 1;
    }
  }
`;
const ProductDetails = styled.div`
  flex: 3;
  text-align: center;

  @media screen and (min-width: 768px) {
    text-align: left;
  }
`;
const Name = styled.div`
  width: fit-content;
`;
const ProductBrand = styled.div`
  font-weight: 600;
  font-size: 1.5rem;
  @media screen and (min-width: 768px) {
    font-size: 1.875rem;
  }
`;
const ProductName = styled.div`
  font-weight: 400;
  line-height: 160%;
  font-size: 1.5rem;

  @media screen and (min-width: 768px) {
    font-size: 1.875rem;
  }
`;
const ProductPrice = styled.div`
  font-weight: 700;
  font-size: 1.5rem;
  margin: 1.5rem 0;
`;
const ProductAttribute = styled.div`
  font-size: 1.125rem;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 700;
  & + & {
    margin-top: 0.5rem;
  }
`;
const AttributeName = styled.div`
  margin-bottom: 0.5rem;
  text-transform: uppercase;
`;
const AttributeValues = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  @media screen and (min-width: 768px) {
    justify-content: flex-start;
  }
`;
const AttributeValue = styled.div`
  font-size: 14px;
  font-family: "Source Sans Pro", sans-serif;
  color: ${({ name, value, selectedAttributes }) =>
    selectedAttributes[name] === value ? "white" : "black"};
  background-color: ${({ selectedAttributes, name, value, type }) =>
    selectedAttributes[name] === value && type === "text" && "black"};
  background-color: ${({ color }) => color};
  border: ${({ color, selectedAttributes, name, value }) =>
    color && selectedAttributes[name] === value
      ? "solid 2px #5ECE7B"
      : "1px solid black"};
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  background-color: ${({ color }) => color};
  font-family: "Source Sans Pro", sans-serif;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    height: ${({ color }) => (color ? "36px" : "45px")};
    width: ${({ color }) => (color ? "36px" : "64px")};
  }
`;
const ProductActions = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-end;
    align-items: stretch;
  }
`;
const ProductCount = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 1.5rem;
  justify-content: space-between;
  flex-direction: row-reverse;
  @media screen and (min-width: 768px) {
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-top: 0;
  }
`;
const IncrementProduct = styled.div`
  height: 24px;
  width: 24px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  cursor: pointer;
  user-select: none;
  @media screen and (min-width: 768px) {
    height: 45px;
    width: 45px;
  }
`;
const ProductQuantity = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 500;
  @media screen and (min-width: 768px) {
    height: 45px;
    width: 45px;
  }
`;
const DecrementProduct = styled.div`
  height: 24px;
  width: 24px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  user-select: none;
  cursor: pointer;
  @media screen and (min-width: 768px) {
    height: 45px;
    width: 45px;
  }
`;
const ProductPictures = styled.div`
  display: flex;
  position: relative;
  max-width: 300px;
  overflow: hidden;
`;
const Arrow = styled.img`
  height: 24px;
  width: 24px;
  position: absolute;
  bottom: 1rem;
  right: ${({ direction }) => (direction === "right" ? "1rem" : "3rem")};
  cursor: ${({ sliderIndex, galleryLength, direction }) => {
    if (sliderIndex === 0 && direction === "left") return "default";
    else if (sliderIndex === galleryLength && direction === "right")
      return "default";
    else return "pointer";
  }};
  z-index: 10;
`;
const PicturesSlider = styled.div`
  width: 100%;
  display: flex;
  transition: transform 0.3s ease;
  transform: translateX(-${({ sliderIndex }) => sliderIndex * 100}%);
`;
const Image = styled.img`
  object-fit: contain;
  height: 300px;
  width: 100%;
  flex-shrink: 0;
  margin: 1rem 0;
  @media screen and (min-width: 768px) {
    margin: 0;
  }
`;
const Hr = styled.hr`
  border: 1px solid #e5e5e5;
  margin: 1.875rem 0;
`;
class CartProduct extends Component {
  constructor() {
    super();
    this.state = { sliderIndex: 0 };
  }
  render() {
    if (this.props.product.productDetails) {
      const {
        id,
        name,
        brand,
        prices,
        attributes,
        gallery,
        selectedAttributes,
      } = this.props.product.productDetails;
      const selectedPrice = prices.find(
        (price) => price.currency.label === this.props.currencyState.label
      );
      return (
        <>
          <Product>
            <ProductDetails>
              <Name>
                <Link to={`/product/${id}`}>
                  <ProductBrand>{brand}</ProductBrand>
                  <ProductName>{name}</ProductName>
                </Link>
              </Name>

              <ProductPrice>
                {selectedPrice?.currency.symbol}
                {selectedPrice?.amount.toFixed(2)}
              </ProductPrice>
              {attributes.map((attribute) => {
                return (
                  <ProductAttribute key={attribute.name}>
                    <AttributeName>{attribute.name}</AttributeName>
                    <AttributeValues>
                      {attribute.items.map((item) => {
                        if (attribute.type === "swatch")
                          return (
                            <AttributeValue
                              key={item.value}
                              color={item.value}
                              name={attribute.name}
                              value={item.value}
                              type={attribute.type}
                              lol={selectedAttributes}
                              onClick={() =>
                                this.props.dispatch(
                                  changeAttribute({
                                    productDetails:
                                      this.props.product.productDetails,
                                    selectedAttributes: {
                                      ...this.props.product.productDetails
                                        .selectedAttributes,
                                      [attribute.name]: item.value,
                                    },
                                  })
                                )
                              }
                            />
                          );
                        else
                          return (
                            <AttributeValue
                              key={item.value}
                              name={attribute.name}
                              value={item.value}
                              type={attribute.type}
                              selectedAttributes={selectedAttributes}
                              onClick={() =>
                                this.props.dispatch(
                                  changeAttribute({
                                    productDetails:
                                      this.props.product.productDetails,
                                    selectedAttributes: {
                                      ...this.props.product.productDetails
                                        .selectedAttributes,
                                      [attribute.name]: item.value,
                                    },
                                  })
                                )
                              }
                            >
                              {item.value}
                            </AttributeValue>
                          );
                      })}
                    </AttributeValues>
                  </ProductAttribute>
                );
              })}
            </ProductDetails>
            <ProductActions>
              <ProductCount>
                <IncrementProduct
                  onClick={() =>
                    this.props.dispatch(
                      addProduct({
                        productDetails: this.props.product.productDetails,
                      })
                    )
                  }
                >
                  +
                </IncrementProduct>
                <ProductQuantity>{this.props.product.quantity}</ProductQuantity>
                <DecrementProduct
                  onClick={() =>
                    this.props.dispatch(
                      removeProduct({
                        productDetails: this.props.product.productDetails,
                      })
                    )
                  }
                >
                  -
                </DecrementProduct>
              </ProductCount>
              <ProductPictures>
                {gallery.length > 1 && (
                  <>
                    <Arrow
                      src={LeftArrow}
                      direction="left"
                      sliderIndex={this.state.sliderIndex}
                      onClick={() =>
                        this.state.sliderIndex > 0 &&
                        this.setState({
                          sliderIndex: this.state.sliderIndex - 1,
                        })
                      }
                    />
                    <Arrow
                      src={RightArrow}
                      direction="right"
                      sliderIndex={this.state.sliderIndex}
                      galleryLength={gallery.length - 1}
                      onClick={() =>
                        this.state.sliderIndex < gallery.length - 1 &&
                        this.setState({
                          sliderIndex: this.state.sliderIndex + 1,
                        })
                      }
                    />
                  </>
                )}

                <PicturesSlider sliderIndex={this.state.sliderIndex}>
                  {gallery.map((image) => (
                    <Image key={image} src={image} />
                  ))}
                </PicturesSlider>
              </ProductPictures>
            </ProductActions>
          </Product>
          <Hr />
        </>
      );
    }
  }
}

export default connect(mapStateToProps)(CartProduct);
